import { render, staticRenderFns } from "./DeviceLicenses.vue?vue&type=template&id=650ee1f3"
import script from "./DeviceLicenses.vue?vue&type=script&lang=js"
export * from "./DeviceLicenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports